import script from "./CompetitiveRedEnvelope.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitiveRedEnvelope.vue?vue&type=script&setup=true&lang=ts"

import "./CompetitiveRedEnvelope.vue?vue&type=style&index=0&id=dd58505a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd58505a"]])

export default __exports__